// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-content-new{
color: #008fc7 ;
padding: 20px;
}
.cut-word{
    max-width: 25em !important;
 }`, "",{"version":3,"sources":["webpack://./src/app/views/page-templates/add-edit-page-templates/add-edit-page-template.component.css"],"names":[],"mappings":"AAAA;AACA,eAAe;AACf,aAAa;AACb;AACA;IACI,0BAA0B;CAC7B","sourcesContent":[".card-content-new{\r\ncolor: #008fc7 ;\r\npadding: 20px;\r\n}\r\n.cut-word{\r\n    max-width: 25em !important;\r\n }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
